import React from 'react';

const STATUS_MAP = {
  active: 'ednl-badge--success',
  enabled: 'ednl-badge--success',
  true: 'ednl-badge--success',
  inactive: 'ednl-badge--muted',
  disabled: 'ednl-badge--muted',
  false: 'ednl-badge--muted',
  warning: 'ednl-badge--warning',
  critical: 'ednl-badge--danger',
  error: 'ednl-badge--danger',
  info: 'ednl-badge--info',
  accumulating: 'ednl-badge--info',
  ready: 'ednl-badge--success',
  submitted: 'ednl-badge--muted',
  expired: 'ednl-badge--warning',
};

export default function StatusBadge({ status, label }) {
  const text = label || String(status);
  const cls = STATUS_MAP[String(status).toLowerCase()] || 'ednl-badge--muted';
  return <span className={`ednl-badge ${cls}`}>{text}</span>;
}
